import {Component, Input, OnInit} from '@angular/core';
import {ContactDetailsResponse, MsisdnStatusResponse, ReferenceBookResponse, ReferenceBookType} from '@npck/af-frontend-api';
import {DATE_UI_FORMAT} from '@npck/libs/commons';
import {Column, ColumnType, Row, StatusColumn} from '../../../../../../../components/full-table/table/table.component';
import {mapMsisdnStatusToStyle} from '../../../../../../../components/status/status.component';
import {DictionaryHolderService, resolveRefName} from '../../../../../../../domain/dictionary-holder.service';
import dayjs from 'dayjs';

@Component({
    selector: 'af-contact-status-history-tab',
    templateUrl: 'contact-status-history-tab.component.html',
    standalone: false,
})
export class ContactStatusHistoryTabComponent implements OnInit {
    @Input() contactDetails: ContactDetailsResponse;
    dataSource: Row[] = [];

    private msisdnStatuses: ReferenceBookResponse[] = [];

    constructor(
        private dictionaryHolderService: DictionaryHolderService,
    ) {
    }

    ngOnInit(): void {
        if (!this.contactDetails.statusHistory?.length) {
            return;
        }
        this.dictionaryHolderService.getReference(ReferenceBookType.MSISDN_STATUS)
            .subscribe(msisdnStatuses => {
                this.msisdnStatuses = msisdnStatuses;
                this.dataSource = this.contactDetails.statusHistory.map(item => this.buildRow(item));
            });
    }

    private buildRow(item: MsisdnStatusResponse): Row {
        const ownershipPeriod = this.formatOwnershipPeriod(item.checkFromDate, item.checkToDate);
        const msisdnStatusDisplay = item.status
            ? resolveRefName(this.msisdnStatuses, item.status)
            : '';

        return <Row>{
            createdDate: <Column>{
                type: ColumnType.DATE_TIME_SECONDS,
                text: item.createdDate,
            },
            ownershipPeriod: <Column>{
                type: ColumnType.TEXT,
                text: ownershipPeriod,
            },
            msisdnStatus: <StatusColumn>{
                type: ColumnType.STATUS,
                text: msisdnStatusDisplay,
                style: mapMsisdnStatusToStyle(item.status),
            },
            createdBy: <Column>{
                type: ColumnType.TEXT,
                text: item.createdBy,
            },
        };
    }

    private formatOwnershipPeriod(fromDate: string, toDate: string): string {
        const from = fromDate ? dayjs(fromDate).format(DATE_UI_FORMAT) : '';
        const to = toDate ? dayjs(toDate).format(DATE_UI_FORMAT) : '';
        if (from && to) {
            return `${from} - ${to}`;
        }
        return from || to || '';
    }
}
